import {
  BiBarGap,
  BiCornerRadius,
  kBiVizStyleOptionNames,
} from '@euler/model/bi/viz';
import { memo } from 'react';
import { BiChip } from '../../../../components/ui/BiChip';
import { StyleGroup } from '../StyleGroup';
import { StyleRow } from '../StyleRow';
import { biPatchedOption, biWithStyleOption } from '../functions/biStyleEdit';
import { BiStyleOptionProps } from '../functions/biStyleOptionProps';

const kRadii: Array<{ value: BiCornerRadius; label: string }> = [
  { value: 0, label: '直角' },
  { value: 4, label: '小圆角' },
  { value: 8, label: '大圆角' },
];

const kGaps: Array<{ value: BiBarGap; label: string }> = [
  { value: BiBarGap.Narrow, label: '窄' },
  { value: BiBarGap.Normal, label: '标准' },
  { value: BiBarGap.Wide, label: '宽' },
];

/** Bar corners and the gap between bars. */
export const BarOptions = memo(({ style, onChange }: BiStyleOptionProps) => {
  const bar = biPatchedOption(style, 'bar', {});
  const set = (patch: Partial<typeof bar>) =>
    onChange(
      biWithStyleOption(style, 'bar', biPatchedOption(style, 'bar', patch)),
    );
  return (
    <StyleGroup
      title={kBiVizStyleOptionNames.bar}
      onReset={
        style?.bar
          ? () => onChange(biWithStyleOption(style, 'bar', undefined))
          : null
      }
    >
      <StyleRow label="圆角">
        {kRadii.map(radius => (
          <BiChip
            key={radius.value}
            label={radius.label}
            selected={bar.cornerRadius === radius.value}
            onPress={() => set({ cornerRadius: radius.value })}
          />
        ))}
      </StyleRow>
      <StyleRow label="间距">
        {kGaps.map(gap => (
          <BiChip
            key={gap.value}
            label={gap.label}
            selected={bar.gap === gap.value}
            onPress={() => set({ gap: gap.value })}
          />
        ))}
      </StyleRow>
    </StyleGroup>
  );
});
